import React, { useEffect } from 'react';

import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/default';

import themeToCssVars from 'utils/generateCssVars';

const ThemeCustomization = ({ children }) => {

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = themeToCssVars(theme);
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}


export default ThemeCustomization;
